import { Heart, Sparkles, Moon, Baby, Briefcase } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { IMAGES } from "@/constants/neco";

const ORGS = [
  { icon: Heart, name: "Düğün", desc: "Rüyaların düğününe ev sahipliği yapıyoruz; her detay titizlikle planlanır." },
  { icon: Sparkles, name: "Nişan", desc: "Düğün kadar görkemli nişanlar için ihtişamlı salonlar." },
  { icon: Moon, name: "Kına", desc: "Geleneksel kına gecelerinize özel konsept ve ikramlar." },
  { icon: Baby, name: "Sünnet", desc: "Asla unutulmayacak sünnet organizasyonları için geniş seçenekler." },
  { icon: Briefcase, name: "Kurumsal Etkinlik", desc: "Konser, tiyatro ve toplantılarınız için teknik donanımı eksiksiz salonlar." },
];

export const Organizations = () => (
  <section id="organizasyonlar" data-testid={HOME.orgsSection} className="relative py-24 md:py-32 overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMAGES.corporate} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-10" loading="lazy" />
      <div className="absolute inset-0 bg-[#121110]/80" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
      <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Organizasyonlarımız</p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] mt-5 gold-rule max-w-3xl">
        Her Özel Gün İçin <span className="font-romance text-[#E5C783]">Mükemmel Deneyim</span>
      </h2>
      <p className="mt-12 max-w-2xl text-base font-light leading-relaxed text-[#B3B0A8]">
        Düğün, nişan, kına ve kurumsal organizasyonlarınız için salonları ve ikramlarıyla size
        mükemmel ve unutulmaz bir deneyim sunuyoruz.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15 mt-14">
        {ORGS.map(({ icon: Icon, name, desc }) => (
          <div key={name} className="bg-[#121110] p-8 hover:bg-[#1A1817] transition-colors duration-500 group">
            <Icon size={26} strokeWidth={1} className="text-[#D4AF37] transition-transform duration-500 group-hover:-translate-y-1" />
            <h3 className="font-display text-2xl text-[#F5F5F0] mt-5 group-hover:text-[#E5C783] transition-colors duration-300">{name}</h3>
            <p className="text-xs font-light leading-relaxed text-[#B3B0A8] mt-3">{desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
